import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";

const useIsRoute = (path: string) => {
  const [isRoute, setIsRoute] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const isActive = location.pathname === path;
    setIsRoute(isActive);
  }, [location, path, setIsRoute]);

  return isRoute;
};

export default useIsRoute;
